import Cookie from "js-cookie";
import { getConfigurationSettingByDevelopmentKey, ConfigContentType } from "../../services/content/config.lib.js";
import { cachingFetcher } from "../agent/cachingFetcher.js";
import { createUUID } from "../index.js";
import { getProductTileConfigData } from "../../components/Product/ProductTile/ContentStack/index.js";
import { EVENT_TYPES, PLACEMENT_NAMES, CRITEO_USER_COOKIE } from "./constants.js";
import { getQueryString } from "./lib.js";
const generateCriteoCookie = () => {
  let cookie = localStorage.getItem("CRITEO_USER_COOKIE");
  if (!cookie) {
    cookie = createUUID();
    localStorage.setItem("CRITEO_USER_COOKIE", cookie);
  }
  Cookie.set(CRITEO_USER_COOKIE, cookie, {
    expires: 30,
    path: "/"
  });
  return cookie;
};
const queryCriteo = async ({
  endpoint,
  timeout,
  connection_timeout,
  sharedQueryParams,
  placementName,
  category,
  isMobile,
  queryString,
  returnAllPlacements
}) => {
  var _a;
  const deviceType = isMobile ? "mobile" : "desktop";
  const pageId = `${EVENT_TYPES[PLACEMENT_NAMES[placementName]]}${deviceType}`;
  let builtQueryString = queryString;
  if (!builtQueryString) {
    builtQueryString = getQueryString({
      ...sharedQueryParams,
      category,
      "event-type": PLACEMENT_NAMES[placementName],
      "page-id": pageId
    });
  }
  let data;
  let error;
  try {
    const controller = new AbortController();
    const { signal } = controller;
    if (connection_timeout) {
      setTimeout(() => {
        try {
          controller.abort();
        } catch (err) {
          console.error(`Failed aborting criteo api call`, err);
        }
      }, connection_timeout);
    }
    const url = `${endpoint}?${builtQueryString}`;
    const requestInit = {
      signal: connection_timeout ? signal : void 0
    };
    const searchResults = await cachingFetcher(
      url,
      requestInit,
      timeout,
      false
    ).then((res) => res);
    if (searchResults && searchResults.status === "OK") {
      const placements = (_a = searchResults.placements) == null ? void 0 : _a.map(
        (placement) => {
          return Object.keys(placement).reduce(
            (newPlacement, placementKey) => {
              newPlacement[placementKey.toLowerCase()] = placement[placementKey];
              return newPlacement;
            },
            {}
          );
        }
      );
      const normalizedCriteoData = {
        OnLoadBeacon: searchResults.OnLoadBeacon,
        "page-uid": searchResults.OnLoadBeacon,
        placement: findCriteoPlacement(
          `${pageId}-${placementName}`,
          placements
        ),
        placements: returnAllPlacements ? placements : void 0
      };
      data = normalizedCriteoData;
    }
  } catch (err) {
    if (err instanceof DOMException && err.name === "AbortError") {
      console.info("Criteo fetch timed out and was aborted.");
    } else {
      console.error(
        `Error fetching Criteo Data for ${placementName} on ${deviceType}: `,
        err
      );
    }
    error = err;
  }
  return { data, error };
};
const getCriteoContentStackConfigurationEntries = async (locale) => {
  const productTileConfigData = await getProductTileConfigData(true, locale);
  const criteoAPIConfigurationSettings = await getConfigurationSettingByDevelopmentKey(
    ConfigContentType.ServiceConfiguration,
    "criteo_service_config"
  );
  return {
    criteoAPIConfigurationSettings,
    productTileConfigData
  };
};
const findCriteoPlacement = (placementKey, placements) => {
  var _a, _b;
  const lowerCasePlacementKey = placementKey.toLowerCase();
  return (_b = (_a = placements == null ? void 0 : placements.find((placement) => {
    return placement[lowerCasePlacementKey];
  })) == null ? void 0 : _a[lowerCasePlacementKey]) == null ? void 0 : _b[0];
};
export {
  findCriteoPlacement,
  generateCriteoCookie,
  getCriteoContentStackConfigurationEntries,
  queryCriteo
};
